import { getConfigValue } from "@rumble-it/common-lib/src/config";
import axios from "axios";

export const authenticate = async (): Promise<string> => {
  const clientId = localStorage.getItem("clientId");
  const clientSecret = localStorage.getItem("clientSecret");

  if (!clientId || !clientSecret) {
    throw new Error("No credentials provided");
  }

  return await axios
    .post(
      "/protocol/openid-connect/token",
      {
        grant_type: "client_credentials",
        client_id: clientId,
        client_secret: clientSecret,
        scope: "openid organization:* email profile",
      },
      {
        baseURL: `${getConfigValue("authUrl")}/realms/${getConfigValue("authRealm")}`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Accept: "application/json, text/plain, */*",
        },
      },
    )
    .then(({ data }) => {
      localStorage.setItem("accessToken", data.access_token);
      return data.access_token;
    });
};
